const nop = () => {
    // do nothing
}

export default nop
